<script setup>
import {defineComponent, onMounted, ref, useTemplateRef} from 'vue'
import {loadPayline} from '@/payline-helper.js'
import {useRoute} from 'vue-router'
import axios from 'axios'

defineComponent({
  name: 'Rechargement'
})

// Commun
const titres = ref([])
const numeroRechargement = ref(null)
const email = ref(null)
const suiteForm = ref(false)
const paymentToken = ref(undefined)
const isAchatCollapsed = ref(false)
const isPaiementCollapsed = ref(true)
const loadingTitre = ref(false)
const loading = ref(false)
const erreurMessage = ref(null)
const now = new Date()
const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
const titreSelectionne = ref("")
let dateDebutTitre = ref('')
const prenom = ref(null)
const nom = ref(null)
const justificatifProduitFile = ref(null)
const justificatifValidationMessage = ref("")

// Achat
const produit = ref(null)
let dateDebutNewTitre = ref(today)
let nouvelleDateFinValiditeeNewTitre = ref(today)
let isNewTitreSelected = ref(false)
const catalogue = ref([])
const carteVide = ref(null)
let numRechargementSelectionne = null

const rechargementBloque = ref(false)

const titreList = useTemplateRef('titre-list')

const route = useRoute()

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value
  isPaiementCollapsed.value = !isPaiementCollapsed.value
}

onMounted(() => {
  window.handleFinalStateReached = handleFinalStateReached
  window.handleWidgetDidShowState = handleWidgetDidShowState

  if (route.params.rechargementId) {
    numeroRechargement.value = route.params.rechargementId
    verifierRechargement()
  }
})

function valideStepOne(e) {
  if (!titreSelectionne.value && !produit.value) {
    e.preventDefault()
    return
  }

  if (isNewTitreSelected.value) {
    achat(e)
  } else {
    rechargement(e)
  }
}

// Rechargement
function rechargement(e) {
  e.preventDefault()
  if (loading.value) {
    return
  }
  loading.value = true

  axios.post('/commandes/prepareRechargement', {
    codeProduit: titreSelectionne.value.codeProduit,
    prenom: prenom.value,
    nom: nom.value,
    email: email.value,
    titreARecharger: titreSelectionne.value.titreId,
    dateDebutTitre: dateDebutTitre.value,
    needFacture: false,
    justificatifProduitFile: justificatifProduitFile.value,
    reductionId: titreSelectionne.value.reductionId
  })
    .then(
      succes => {
        paymentToken.value = succes.data.token
        loadPayline(succes.data.production).then(() => {
          toggleCollapse()
          loading.value = false
        })
      },
      erreur => {
        loadingTitre.value = false
        erreurMessage.value = erreur?.response?.data || 'Erreur lors de la préparation de la commande.'
      }
    )
}

function calculateMinDate(finValiditeeStr) {
  if ((new Date(finValiditeeStr)) < new Date(today)) {
    return today
  } else {
    let newDate = new Date(finValiditeeStr)
    newDate.setDate(newDate.getDate() + 1)
    return `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`
  }
}

function deselectionnerTitre() {
  isNewTitreSelected.value = true
  titreSelectionne.value = ""
}

async function dateValiditee() {
  if (titreSelectionne.value.nouvelleFinValiditee !== null) {
    axios.get('/titres/calculerDateFin', {
      params: {
        dateRechargement: dateDebutTitre.value,
        titreid: titreSelectionne.value.titreId
      }
    })
      .then(succes => {
        titreSelectionne.value.nouvelleFinValiditee = succes.data
      }, erreur => {
        if (erreur.data === undefined) {
          erreurMessage.value = 'Erreur lors de la récuperation des titres.'
        } else {
          if (erreur.data.status === 500) {
            erreurMessage.value = 'Erreur lors de la récuperation des titres.'
          } else {
            erreurMessage.value = erreur.response.data
          }
        }
        titreSelectionne.value.nouvelleFinValiditee = ''
      })
  }
}

// Achat
function achat(e) {
  e.preventDefault()
  if (loading.value === true) {
    return
  }
  loading.value = true

  axios.post('/commandes/prepareVente', {
    codeProduit: produit.value.codeProduit,
    prenom: prenom.value,
    nom: nom.value,
    email: email.value,
    numeroRechargement: numRechargementSelectionne,
    dateDebutTitre: dateDebutTitre.value,
    needFacture: false,
    justificatifProduitFile: justificatifProduitFile.value,
    reductionId: produit.value.reductionId
  })
  .then(
    succes => {
      paymentToken.value = succes.data.token
      loadPayline(succes.data.production).then(() => {
        toggleCollapse()
      })
    },
    erreur => {
      erreurMessage.value = erreur?.response?.data || 'Erreur lors de la préparation de la commande.'
    }
  )
  .finally(() => {
    loading.value = false
  })
}

function selectionnerTitre() {
  produit.value = null
  isNewTitreSelected.value = false
  if (titreSelectionne.value.finValiditee !== null) {
    dateDebutTitre.value = calculateMinDate(titreSelectionne.value.finValiditee)
  }
}

function detailValiditee(titre) {
  if (typeof titre.nbTrajets === 'number' && titre.nbTrajets > 0) {
    return ' solde : ' + titre.nbTrajets + ' trajet(s)'
  } else if (typeof titre.nbTrajets === 'number' && titre.nbTrajets === 0) {
    return ' solde : épuisé'
  } else if (typeof titre.finValiditee === 'string' && titre.finValiditee.length > 0) {
    return ' expire le : ' + toFrenchDate(titre.finValiditee)
  }
  return ''
}

function detailFutureValiditee(titre) {
  if (typeof titre.nouveauNbTrajets === 'number' && titre.nouveauNbTrajets > 0) {
    return ' Solde après rechargement : ' + titre.nouveauNbTrajets + ' trajet(s)'
  } else if (typeof titre.nouvelleFinValiditee === 'string' && titre.nouvelleFinValiditee.length > 0) {
    return ' Expiration après rechargement : ' + toFrenchDate(titre.nouvelleFinValiditee)
  }
  return ''
}

async function dateValiditeeNewTitre() {
  if (produit.value && produit.value.type.includes('Abonnement')) {
    axios.get('/titres/calculerDateFinNewTitre', {
      params: {
        dateRechargement: dateDebutNewTitre.value,
        codeProduit: produit.value.codeProduit
      }
    }).then(succes => {
      nouvelleDateFinValiditeeNewTitre.value = succes.data
    })
  }
}

function resetSelections() {
  titreSelectionne.value = ""
  produit.value = null
  isNewTitreSelected.value = false
  dateDebutTitre.value = ''
  dateDebutNewTitre.value = today
  nouvelleDateFinValiditeeNewTitre.value = today
  prenom.value = null
  nom.value = null
  justificatifProduitFile.value = null
  justificatifValidationMessage.value = ""
  paymentToken.value = undefined
  suiteForm.value = false
}

// Commun
function verifierRechargement() {
  resetSelections()

  if (numeroRechargement.value === null || numeroRechargement.value === '') {
    erreurMessage.value = "Un numéro de carte est obligatoire."
    return
  }

  numeroRechargement.value = numeroRechargement.value.replace(/\s/g, '')

  erreurMessage.value = null
  loadingTitre.value = true
  suiteForm.value = false
  titres.value = []
  carteVide.value = null
  numRechargementSelectionne = numeroRechargement.value

  axios.get('/titres', {
    params: {
      numeroRechargement: numRechargementSelectionne,
      dateRechargement: dateDebutTitre.value == null ? null : dateDebutTitre.value.toLocaleString()
    }
  })
    .then(succes => {
      if (succes.data === "CARTE_NON_CONNUE") {
        carteVide.value = true
      } else {
        titres.value = succes.data
        carteVide.value = false
      }
      suiteForm.value = true

      setTimeout(() => {
        titreList.value.scrollIntoView({ behavior: 'smooth' })
      }, 500)
    }, erreur => {
      const message = erreur.response?.data
      rechargementBloque.value = false
      if (erreur.status === 400) {
        erreurMessage.value = message
        rechargementBloque.value = true
        titres.value = []
        carteVide.value = true
        suiteForm.value = true
      } else {
        erreurMessage.value = erreur.response?.data ?? 'Titre introuvable.'
      }
    })
    .finally(() => {
      loadingTitre.value = false
    })

  axios.get('produits/produit-rechargement/' + numeroRechargement.value, {
    params: {
      seeReduction: true,
      showReductionLibelle: true
    }
  })
    .then(succes => {
      catalogue.value = succes.data
      catalogue.value.sort((one, two) => (one.libelle > two.libelle ? 1 : -1))
    }, erreur => {
      if (erreur.data === undefined) {
        erreurMessage.value = 'Erreur lors de la récuperation du catalogue.'
      } else {
        if (erreur.data.status === 500) {
          erreurMessage.value = 'Erreur lors de la récuperation du catalogue.'
        } else {
          erreurMessage.value = erreur.response.data
        }
      }
    })
}

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
}

function toFrenchDate(value) {
  if (value == null || value === '') {
    return ''
  }
  return new Intl.DateTimeFormat('fr-FR').format(new Date(value))
}

function onChangeJustificatifProduitFile(event) {
  const file = event.target.files[0]
  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessage.value = "Format incorrect. Veuillez télécharger un PDF"
    event.target.value = null
  } else {
    justificatifValidationMessage.value = ""
    justificatifProduitFile.value = file
  }
}

function handleFinalStateReached(param) {
  if (!param) {
    return true
  }
  switch (param.state) {
    case 'PAYMENT_SUCCESS':
    case 'PAYMENT_SUCCESS_FORCE_TICKET_DISPLAY':
    case 'PAYMENT_ONHOLD_PARTNER':
      return true
    default:
      erreurMessage.value = 'Échec lors du paiement'
      return false
  }
}

function handleWidgetDidShowState(param) {
  if (param.state === 'PAYMENT_METHODS_LIST') {
    window.webPaymentLoaded = true
  }
}
</script>

<template>
  <div
    :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }"
    :aria-hidden="!isPaiementCollapsed"
    class="overflow-auto"
  >
    <div id="rechargement">
      <form @submit="valideStepOne" :aria-busy="loading">
        <div class="achat container">
          <h1>Rechargement de votre titre de transport</h1>

          <div class="form_recharge">
            <div class="carte_recharge card">
              <div class="card-body">

                <!-- IMAGE -->
                <div class="num_rechargement text-center row m-2 d-block mx-auto">
                  <img
                    src="@/assets/carte-numero.jpg"
                    alt="Exemple de carte de transport avec emplacement du numéro sur le côté"
                  />
                </div>

                <p id="hint-numero-carte">Indiquez le numéro présent sur le côté de votre titre (8 à 10 chiffres)</p>
                <div class="div_icon_input row">
                  <div class="col-sm-1 d-none d-sm-block" aria-hidden="true">
                    <i class="fas fa-ticket-alt fa-2x"></i>
                  </div>
                  <div class="col-sm-9 col-10">
                    <label for="numeroCarte" class="visually-hidden">Numéro de carte (8 à 10 chiffres)</label>
                    <input
                      id="numeroCarte"
                      type="text"
                      v-model="numeroRechargement"
                      placeholder="3 273 017 891"
                      class="input_number form-control"
                      aria-describedby="hint-numero-carte"
                      required
                    />
                  </div>
                  <div class="col-sm-2 col-2">
                    <button type="button" class="btn_verif btn" @click="verifierRechargement">
                      Vérifier
                    </button>
                  </div>
                </div>

                <!-- MESSAGES -->
                <div
                  role="alert"
                  aria-live="polite"
                  class="fs-6 text-center text-danger my-3"
                >
                  <template v-if="!rechargementBloque && erreurMessage">{{ erreurMessage }}</template>
                </div>

                <p
                  role="alert"
                  aria-live="assertive"
                  class="text-warning text-center"
                >
                  <template v-if="rechargementBloque">{{ erreurMessage }}</template>
                </p>

                <p class="text-center" aria-live="polite">
                  <template v-if="carteVide">Remarque : Merci de vérifier le numéro de carte saisi.</template>
                </p>

                <!-- LOADER -->
                <div class="div_loader_titre" aria-live="polite">
                  <template v-if="loadingTitre">
                    <div class="spinner-border loaderTitre" aria-hidden="true"></div>
                    <span class="visually-hidden">Chargement des titres en cours ...</span>
                  </template>
                </div>

                <p v-if="titres.length > 0 || carteVide !== null">
                  Choisissez le produit que vous souhaitez recharger ou acheter :
                </p>

                <fieldset class="container choix_titre" ref="titre-list">
                  <legend class="visually-hidden">
                    Sélection du titre à recharger ou acheter
                  </legend>

                  <div class="row gy-1">

                    <!-- TITRES EXISTANTS -->
                    <div
                      v-if="titres.length > 0 && carteVide !== null"
                      v-for="titre in titres"
                      :key="titre.titreId"
                      class="col-md-6 col-12 align-items-stretch"
                    >
                      <div class="div_nature h-100 p-2">

                        <div class="text-center d-flex flex-column align-items-center">

                          <!-- RADIO -->
                          <input
                            @change="selectionnerTitre"
                            v-model="titreSelectionne"
                            type="radio"
                            name="nature"
                            :id="titre.titreId"
                            :value="titre"
                            :disabled="rechargementBloque || paymentToken !== undefined || titre.currentCommandeRechargementExists"
                            required
                          />

                          <label :for="titre.titreId" class="mt-1 card-label">
                            {{ titre.libelleProduit }}
                          </label>

                          <i>( {{ detailValiditee(titre) }} )</i>

                          <!-- DATE -->
                          <div
                            v-if="titre.titreId === titreSelectionne.titreId && titre.finValiditee != null"
                            class="row w-100 pb-2 mt-2"
                          >
                            <label
                              :for="`date-${titre.titreId}`"
                              class="col-12 col-sm-7 text-center align-self-center"
                            >
                              Date de rechargement
                            </label>

                            <div class="col-sm-5 col-12">
                              <input
                                :id="`date-${titre.titreId}`"
                                type="date"
                                class="form-control"
                                v-model="dateDebutTitre"
                                @change="dateValiditee"
                                :min="calculateMinDate(titre.finValiditee)"
                                required
                              />
                            </div>
                          </div>

                          <!-- INFOS -->
                          <span v-if="titre.tarif !== null && !titre.currentCommandeRechargementExists">
            Coût du rechargement : {{ toCurrency(titre.tarif) }}
          </span>

                          <i
                            v-if="titreSelectionne === titre && !titre.currentCommandeRechargementExists && titreSelectionne.nouvelleFinValiditee === null"
                          >
                            ( {{ detailFutureValiditee(titre) }} )
                          </i>

                          <i
                            v-else-if="titreSelectionne === titre && !titre.currentCommandeRechargementExists && titre.nouvelleFinValiditee !== null"
                          >
                            Expiration après rechargement :
                            <u>{{ toFrenchDate(titreSelectionne.nouvelleFinValiditee) }}</u>
                          </i>

                          <div
                            v-else-if="titre.currentCommandeRechargementExists"
                            class="text-danger font-weight-bold"
                          >
                            Rechargement en cours, vous ne pouvez recharger ce titre pour le moment.
                          </div>

                        </div>
                      </div>
                    </div>

                    <!-- NOUVEAU TITRE -->
                    <div class="col-md-6 col-12 align-items-stretch">
                      <div
                        class="div_nature h-100 p-2"
                        v-if="titres.length > 0 || carteVide !== null"
                      >

                        <div class="text-center d-flex flex-column align-items-center">

                          <!-- RADIO -->
                          <input
                            type="radio"
                            name="nature"
                            id="newTitre"
                            :disabled="catalogue.length === 0"
                            @change="deselectionnerTitre"
                            required
                          />

                          <label for="newTitre" class="mt-1 card-label">
                            <span class="h6 mb-0">Achat d'un nouveau titre</span>
                          </label>

                          <div v-if="catalogue.length === 0 || carteVide === null" class="text-danger font-weight-bold">
                            Il n'est pas possible d'ajouter un titre à cette carte.
                          </div>

                          <p v-else-if="!isNewTitreSelected">
                            Si vous souhaitez ajouter un titre à votre carte, cliquez ici.
                          </p>

                          <!-- SELECT PRODUIT -->
                          <div class="row w-100 mt-2" v-if="isNewTitreSelected">
                            <div class="col-12">
                              <label for="produit-select" class="visually-hidden">
                                Sélectionner un produit
                              </label>

                              <select
                                id="produit-select"
                                v-model="produit"
                                @change="dateValiditeeNewTitre"
                                class="form-control my-2"
                                required
                              >
                                <option disabled :value="null">
                                  Veuillez sélectionner un produit
                                </option>

                                <option
                                  v-for="item in catalogue"
                                  :key="item.id"
                                  :value="item"
                                >
                                  {{ item.libelle }} ({{ toCurrency(item.tarif) }})
                                </option>
                              </select>
                            </div>
                          </div>

                          <!-- DATE NOUVEAU -->
                          <div
                            v-if="produit && produit.type.includes('Abonnement')"
                            class="row w-100 pb-2"
                          >
                            <label
                              for="date-nouveau-titre"
                              class="col-12 col-sm-7 text-center align-self-center"
                            >
                              Date de rechargement
                            </label>

                            <div class="col-sm-5 col-12">
                              <input
                                id="date-nouveau-titre"
                                type="date"
                                class="form-control"
                                v-model="dateDebutNewTitre"
                                @change="dateValiditeeNewTitre"
                                :min="today"
                                required
                              />
                            </div>
                          </div>

                          <!-- INFOS -->
                          <span v-if="produit">
            Coût de l'achat : {{ toCurrency(produit.tarif) }}
          </span>

                          <i v-if="produit && produit.type.includes('Abonnement')">
                            Expiration après achat :
                            <u>{{ toFrenchDate(nouvelleDateFinValiditeeNewTitre) }}</u>
                          </i>

                          <i v-if="produit && produit.type === 'Trajet'">
                            Solde après achat : {{ produit.uniter }} trajet(s)
                          </i>

                        </div>
                      </div>
                    </div>

                  </div>
                </fieldset>

                <!-- FORMULAIRE IDENTITE -->
                <p class="visually-hidden" aria-live="polite">
                  <template v-if="(suiteForm && titreSelectionne !== '') || (isNewTitreSelected && produit)">
                    Formulaire des informations du titulaire disponible
                  </template>
                </p>
                <div
                  v-if="(suiteForm && titreSelectionne !== '') || (isNewTitreSelected && produit)"
                >
                  <fieldset>
                    <legend class="h5 mt-4">
                      Indiquez les informations du titulaire du titre de transport
                    </legend>

                    <!-- PRENOM -->
                    <div class="div_icon_input row">
                      <div class="col-sm-1 d-none d-sm-block" aria-hidden="true">
                        <i class="fas fa-user fa-2x"></i>
                      </div>
                      <div class="col-sm-11">
                        <label for="prenom" class="form-label">Prénom</label>
                        <input
                          v-model="prenom"
                          id="prenom"
                          type="text"
                          class="form-control"
                          autocomplete="given-name"
                          required
                        />
                      </div>
                    </div>

                    <!-- NOM -->
                    <div class="div_icon_input row">
                      <div class="col-sm-11 offset-sm-1">
                        <label for="nom" class="form-label">Nom</label>
                        <input
                          v-model="nom"
                          id="nom"
                          type="text"
                          class="form-control"
                          autocomplete="family-name"
                          required
                        />
                      </div>
                    </div>
                  </fieldset>

                  <fieldset>
                    <legend id="hint-email" class="h5 mt-4">
                      Afin de pouvoir valider votre achat, merci de renseigner votre adresse email :
                    </legend>

                    <div class="div_icon_input row">
                      <div class="col-sm-1 d-none d-sm-block text-center" aria-hidden="true">
                        <i class="fas fa-envelope fa-2x"></i>
                      </div>
                      <div class="col-sm-11">
                        <label for="email" class="form-label">
                          Adresse e-mail
                        </label>
                        <input
                          v-model="email"
                          id="email"
                          type="email"
                          class="form-control"
                          autocomplete="email"
                          aria-describedby="hint-email"
                          required
                        />
                      </div>
                    </div>

                  </fieldset>

                  <!-- JUSTIFICATIF -->
                  <div
                    v-if="(titreSelectionne !== '' && titreSelectionne.libelleProduit.includes('CSS')) || (produit !== null && produit.type.includes('CSS'))"
                    class="mt-3"
                  >
                    <p class="info_mail">
                      Fournissez un justificatif pour la réduction CSS
                    </p>

                    <label for="justificatif" class="form-label">
                      Justificatif (format PDF)
                    </label>

                    <input
                      id="justificatif"
                      ref="justificatifProduit"
                      type="file"
                      @change="onChangeJustificatifProduitFile"
                      accept="application/pdf"
                      class="form-control"
                      required
                    />

                    <p
                      role="alert"
                      :style="{ color: justificatifValidationMessage === 'Format correct.' ? 'green' : '#b91c1c' }"
                    >
                      {{ justificatifValidationMessage }}
                    </p>
                  </div>

                  <!-- BOUTON -->
                  <div class="text-center mt-4">
                    <button class="bouton_valid btn btn-lg" type="submit">
                      Valider
                      <i class="fas fa-arrow-right" aria-hidden="true"></i>
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    :aria-hidden="isPaiementCollapsed"
  >
    <div class="paiement container">
      <h1>Finalisation de votre achat - Paiement</h1>
      <hr/>
      <div class="carte_recap card">
        <div class="card-body">
          <h2 class="h6 card-title">Récapitulatif de votre achat</h2>
          <p v-if="titreSelectionne !== '' && titreSelectionne.tarif !== null" class="card-text">
            Produit : {{ titreSelectionne.libelleProduit }}<br>
            Montant : {{ toCurrency(titreSelectionne.tarif) }}
          </p>
          <p v-if="produit !== null && produit.tarif !== null" class="card-text">
            Produit : {{ produit.libelle }}<br>
            Montant : {{ toCurrency(produit.tarif) }}
          </p>
        </div>
      </div>
      <div class="carte_recap card">
        <div class="card-body">
          <div
            id="PaylineWidget"
            :data-token="paymentToken"
            data-template="column"
            data-auto-init="true"
            data-embeddedredirectionallowed="false"
            data-event-didshowstate="handleWidgetDidShowState"
            data-event-finalstatehasbeenreached="handleFinalStateReached"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/main";

h1 {
  text-align: center;
}

.form_recharge {
  .carte_recharge {
    @include card_shadow;

    .num_rechargement {
      img {
        max-width: 100%;
        height: auto;
        width: 45%;
      }
    }

    .info_mail {
      margin-top: 3rem;
    }

    .bouton_valid {
      display: block;
      margin: auto;
      @include boutons;
    }

    .bouton_valid:hover {
      @include boutons_hover;
    }

    .bouton_valid:focus-visible {
      outline: 3px solid #212529;
      outline-offset: 2px;
    }

    .input_prenom {
      margin-bottom: 2rem;
    }

    .div_icon_input {
      margin-bottom: 1rem;
      @include icon_form;

      .btn_verif {
        @include boutons;
        border-color: transparent;
      }

      .btn_verif:hover {
        @include boutons_hover;
      }

      .btn_verif:focus-visible {
        outline: 3px solid #212529;
        outline-offset: 2px;
      }
    }

    .div_icon_input:focus-within i {
      color: $firstcolor;
    }

    .choix_titre {
      margin: auto;
    }
  }
}

.paiement {
  h1 {
    text-align: center;
  }

  .carte_recap {
    @include card_shadow;

    p {
      text-align: left;
    }
  }
}

.div_loader_titre {
  text-align: center;

  .loaderTitre {
    width: 3rem;
    height: 3rem;
    color: $firstcolor;
  }
}

.div_nature {
  display: flex;
  flex-direction: column;
  background-color: #b7b7b7;
  color: white;
  padding: 1em;
  position: relative;

  .date-de-rechargement {
    word-wrap: normal !important;
    overflow-wrap: normal;
    word-break: keep-all;
    white-space: normal;
  }

  input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  label {
    cursor: pointer;
  }

  &:has(input[type="radio"]:checked) {
    background-color: $firstcolor;
    box-shadow: 0 0 5px #5d5c5c;
  }

  &:has(input[type="radio"]:checked) * {
    background-color: $firstcolor;
    color: white;
    cursor: default;
  }

  &:has(input[type="radio"]:focus-visible) {
    outline: 3px solid #000;
    outline-offset: 2px;
  }

  select {
    color: black !important;
    background: white !important;
    position: relative;
    z-index: 1;
  }

  input[type="date"] {
    color: black !important;
    background: white !important;
    position: relative;
    z-index: 1;
  }

  .card-label {
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 0;
    }
  }

  .row,
  label:not(.card-label) {
    position: relative;
    z-index: 1;
  }

  &:has(input[type="radio"]:checked) .card-label::after,
  &:has(input[type="radio"]:disabled) .card-label::after {
    pointer-events: none;
  }

  &:has(input[type="radio"]:disabled) {
    background-color: lightgray !important;
    color: #999;
  }

  &:has(input[type="radio"]:disabled) * {
    background-color: lightgray !important;
    color: #999;
  }

  input[type="radio"]:focus-visible + label {
    outline: 3px solid black;
  }
}
</style>
